<template>
    
    <div class="row">
         <!-- PRODUCT INFO -->
         <div class="col-12 mt-4 mt-md-0">
                <div class="title-container w-100">
                    <div v-if="this.product && this.product.ref" class="reference text-left mb-2 text-dark font-weight-bold ">{{ this.product.ref }}</div>

                    <div v-if="this.product && this.product.description" class="information text-left mt-4 mb-2">Information</div>
                    <div v-if="this.product && this.product.description" class="brands-title text-left" v-html="formattedDescription"></div>

                    <div v-if="this.product && this.product.description" class="information text-left mt-4 mb-2">Composition</div>
                    <div v-if="this.product && this.product.description" class="brands-title text-left ">{{ product.composition }}</div>
                </div>
              </div>


          <!-- PRODUCT ITEM_PROPERTIES -->
          <div  v-if="this.product && this.product.itemsProperties" class="col-12 col-md-5 mt-4 mt-md-0">

                <div v-for="data in this.product.itemsProperties" :key="data.id" class="mt-3 mb-3 m-0 ml-0 m-md-3">
 
                <span>
                    <img alt="" :src="require('@/assets/images/'+laundrySymbols[data].imageName)"  width="30px" class="mr-2"/>
                    <span class="text-dark font-size-14">{{ laundrySymbols[data].description }}</span>
                </span>
                </div>
          </div>
    </div>

</template>

<script>

import laundrySymbolsData from '@/locales/items-properties.json';


export default ({
    name: "product-page-Info",

    components: {
        
    },

    props: {
        product: Object,
    },

    data() {
    return {

      laundrySymbols: laundrySymbolsData ,
    
    }

    
  },

  mounted() {
    
  },

  computed: {
    formattedDescription() {
        return this.product.description.replace(/\n/g, '<br />');
    }
    },
 
  methods: {
   
  }
})
</script>

<style scoped>


.description {
    position: absolute;
    top: calc(50% - 16px);
    left: 0px;
    letter-spacing: -0.4px;
    line-height: 32px;
    font-weight: 500;
    display: inline-block;
    width: 303px;
}

.reference {
    font-size: 18px;
    line-height: 30px;
    display: inline-block;
    font-family: Inter;
    color: #3e3e59;
}

.information {
    font-size: 20px;
    line-height: 28px;
    font-weight: 500;
    font-family: 'Space Grotesk';
    color: #121212;
}

.brands-title {
    font-size: 18px;
    line-height: 30px;
    color: #525252;
}

.second-container {
    margin: 4%;
    margin-top: 10%;
}

</style>


